//用户权限
export const MENUTYPE = {
    ADMIN: 15, //管理员
    FRANCHISER: 20, //经销商
    LANDLORD: 21, //房东
    TENANT: 22 //房客
}

//登录设备
export const VENDINGTYPE = {
    PC: 1,
    // ANDROID: 9,
    // IOS: 8
}

//接入设备类型
export const DEVICETYPE = {
    ELE: 0,
    WATER: 1,
    HOT_WATER: 3
}

// 公摊
export const SHARESTYPE = {
    PUBLIC: 1,
    PRIVATE: 9
}

//支付方式选择列表用
export const paytypeListOptions = [
    { label: 'lang.all', value: null }, //全部
    { label: 'lang.alipay', value: 1 }, //支付宝
    { label: 'lang.bankcard', value: 2 }, //银行卡
    { label: 'lang.wechat', value: 3 }, //微信
    { label: 'lang.corporateaccount2', value: 5 }, //对公账户
    { label: 'lang.alipaysmall', value: 10 }, //支付宝小程序
    { label: 'lang.wechatsmall', value: 11 }, //微信小程序
    { label: 'lang.alipayappletscancodepayment', value: 12 }, //支付宝小程序扫码支付
    { label: 'lang.wechatappletcodescanningpayment', value: 13 }, //微信小程序扫码支付
    { label: 'lang.other', value: 128 }, //虚拟支付
]

//支付方式表格用
export const paytypeList = [
    { label: 'lang.all', value: null }, //全部
    { label: 'lang.alipay', value: 1 }, //支付宝
    { label: 'lang.wechat', value: 3 }, //微信
    { label: 'lang.alipay', value: 6 }, //新支付宝支付
    { label: 'lang.wechat', value: 7 }, //新微信支付

    { label: 'lang.bankcard', value: 2 }, //银行卡
    { label: 'lang.corporateaccount2', value: 5 }, //对公账户

    { label: 'lang.alipaysmall', value: 10 }, //支付宝小程序
    { label: 'lang.wechatsmall', value: 11 }, //微信小程序
    { label: 'lang.alipaysmall', value: 14 }, //新支付宝小程序支付
    { label: 'lang.wechatsmall', value: 15 }, //新微信小程序支付

    { label: 'lang.alipayappletscancodepayment', value: 12 }, //支付宝小程序扫码支付
    { label: 'lang.wechatappletcodescanningpayment', value: 13 }, //微信小程序扫码支付
    { label: 'lang.alipayappletscancodepayment', value: 16 }, //新支付宝小程序扫码支付
    { label: 'lang.wechatappletcodescanningpayment', value: 17 }, //新微信小程序扫码支付
    { label: 'lang.other', value: 128 }, //虚拟支付
]

export const tokenOperateType = [
    {
        label: "充值",
        value: 1,
    },
    {
        label: "注册",
        value: 2,
    },
    {
        label: "功率门限",
        value: 3,
    },
    {
        label: "清电量",
        value: 4,
    },
    {
        label: "清窃电",
        value: 5,
    },
    {
        label: "房东拉合闸",
        value: 6,
    },
    {
        label: "房客拉合闸",
        value: 7,
    },
    {
        label: "改密钥",
        value: 8,
    },
    {
        label: "注册并充值",
        value: 21,
    },
    {
        label: "恢复出厂设置",
        value: 22,
    },
    {
        label: "清电量并断电",
        value: 23,
    },
]